/*
 * Copyright (c) 2022, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    smallBadge: {
      fontSize: theme.spacing(1.25),
      padding: `${theme.spacing(0)}px ${theme.spacing(0.5)}px`,
    },
    mediumBadge: {
      fontSize: theme.spacing(1.625),
      padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    },
    largeBadge: {
      fontSize: theme.spacing(1.625),
      padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    },
    defaultBadge: {
      borderStyle: 'solid',
      borderRadius: theme.spacing(0.625),
      margin: theme.spacing(0.5),
      display: 'flex',
      width: 'max-content',
      height: 'max-content',
      justifyContent: 'center',
      alignItems: 'center',
    },
    successBadge: {
      backgroundColor: "#36b475",
      color: "#ffffff",
      borderWidth: 0,
    },
    successBadgeOutlined: {
      backgroundColor: "#effdf2",
      color: "#36b475",
      borderColor: "#36b475",
      borderWidth: 1,
    },
    warningBadge: {
      backgroundColor: "#ff9d52",
      color: "#ffffff",
      borderWidth: 0,
    },
    warningBadgeOutlined: {
      backgroundColor: "#fff5eb",
      color: "#ff9d52",
      borderColor: "#ff9d52",
      borderWidth: 1,
    },
    lightBadge: {
      backgroundColor: "#ffffff",
      color: "#1d2028",
      borderWidth: 0,
    },
    lightBadgeOutlined: {
      backgroundColor: "#ffffff",
      color: "#1d2028",
      borderColor: "#8d91a3",
      borderWidth: 1,
    },
    errorBadge: {
      backgroundColor: "#fe523c",
      color: "#ffffff",
      borderWidth: 0,
    },
    errorBadgeOutlined: {
      backgroundColor: "#fceded",
      color: "#fe523c",
      borderColor: "#fe523c",
      borderWidth: 1,
    },
    primaryBadge: {
      backgroundColor: "#5567d5",
      color: "#ffffff",
      borderWidth: 0,
    },
    primaryBadgeOutlined: {
      backgroundColor: "#f0f1fb",
      color: "#5567d5",
      borderColor: "#5567d5",
      borderWidth: 1,
    },
    secondaryBadge: {
      backgroundColor: "#0095ff",
      color: "#ffffff",
      borderWidth: 0,
    },
    secondaryBadgeOutlined: {
      backgroundColor: "#0095ff",
      color: "#0095ff",
      borderColor: "#0095ff",
      borderWidth: 1,
    },
  })
);
